import { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'styled-normalize';

export const GlobalStyles = createGlobalStyle`
  ${normalize}

  ${({ theme }) => css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell,
        'Helvetica Neue', sans-serif;
      ${theme.paragraph.medium.normal};
      color: ${theme.text.onSurface.strong};
      -webkit-font-smoothing: antialiased;
    }

    [tabindex='-1']:focus {
      outline: none !important;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0;
      margin-bottom: 0;
      font-weight: 400;
    }

    p {
      margin-top: 0;
      margin-bottom: 0;
    }

    a {
      background-color: transparent;
      outline: none;
      cursor: pointer;
      transition: color 0.3s;
    }

    ol,
    ul,
    dl {
      margin-top: 0;
      margin-bottom: 1em;
    }

    ol ol,
    ul ul,
    ol ul,
    ul ol {
      margin-bottom: 0;
    }

    img {
      border-style: none;
    }

    strong {
      font-weight: 600;
    }

    .shell-icon path {
      fill: ${theme.text.onSurface.strong};
    }
  `}
`;
